import { initializeApp, getApp } from 'firebase/app'
// import { getFirestore } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth'

const prodConfig = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_ID
}

const config = prodConfig

const clientConfig = {
	apiKey: process.env.REACT_APP_CLIENT_API_KEY,
	authDomain: process.env.REACT_APP_CLIENT_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_CLIENT_DATABASE_URL,
	projectId: process.env.REACT_APP_CLIENT_PROJECT_ID,
	storageBucket: process.env.REACT_APP_CLIENT_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_CLIENT_MESSAGING_SENDER_ID
}

const tmConfig = {
	apiKey: process.env.REACT_APP_TM_API_KEY,
	authDomain: process.env.REACT_APP_TM_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_TM_DATABASE_URL,
	projectId: process.env.REACT_APP_TM_PROJECT_ID,
	storageBucket: process.env.REACT_APP_TM_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_TM_MESSAGING_SENDER_ID
}

// Initialize Firebase
let admin = initializeApp(config)
let auth = getAuth(admin)

if (window.location.host.includes('localhost')) {
	const functions = getFunctions(getApp())
	connectFunctionsEmulator(functions, 'localhost', 5001)
}

let client = initializeApp(clientConfig, 'client')

const team = initializeApp(tmConfig, 'team_member')

const Firebase = {
	// auth
	loginWithEmail: (email, password) => {
		return signInWithEmailAndPassword(auth, email, password)
	},

	signupWithEmail: (email, password) => {
		return createUserWithEmailAndPassword(auth, email, password)
	},

	signOut: () => {
		return auth.signOut()
	},

	auth,

	clientAuth: getAuth(client),

	tmAuth: getAuth(team)
}

export default Firebase
